<template>

    <div class="header-desktop" v-show="innerWidth>=1100">

        <div class="element noselect" :class="{'two-columns': twoColumns}">
            <div class="side" @click="toggleAllMain">
                <img :src="checkboxAllSrcMain" class="img__24 mr__12">
                <span class="text-xlSemibold mr__8">{{ $t('cleaning_title') }}</span>
                <span class="blue-bubble text-baseRegular">{{ totalItemsMain }}</span>
            </div>
            <div class="side" @click="unselectAllMain">
                <div v-show="totalSelectedMain && isSpamList" class="line">
                    <img src="/img/icons/cancel-blue.svg" class="img__20 mr__4">
                    <span
                        class="text-lSemibold color__aquamarine">{{
                            $tc('global_selected', totalSelectedMain, {nbSelected: totalSelectedMain})
                        }}</span>
                </div>
            </div>
        </div>

        <div class="element noselect two-columns" v-show="twoColumns">
            <div class="side" @click="toggleSecondColumn">
                <div v-show="isSpamList">
                    <img :src="checkboxAllSrcSpam" class="img__24 mr__12">
                    <span class="text-xlSemibold mr__8">{{ $t('spam') }}</span>
                    <span class="blue-bubble text-baseRegular">{{ secondList.length }}</span>
                </div>
            </div>
            <div class="side" @click="unselectAllSpam">
                <div v-show="totalSelectedToShow" class="line">
                    <img src="/img/icons/cancel-blue.svg" class="img__20 mr__4">
                    <span
                        class="text-lSemibold color__aquamarine">{{
                            $tc('global_selected', totalSelectedToShow, {nbSelected: totalSelectedToShow})
                        }}</span>
                </div>
            </div>
        </div>

    </div>

</template>

<script>
import Vuex from 'vuex'

export default {

    name: 'list-header-desktop',

    props: {
        mainList: {
            type: [],
            default: () => []
        },
        secondList: {
            type: [],
            default: () => []
        },
        isSpamList: {
            type: Boolean,
            default: false
        },
        twoColumns: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        ...Vuex.mapGetters([
            'innerWidth'
        ]),


        checkboxAllSrcMain() {
            const theyAreAllChecked = this.isSpamList ? this.AreTheyAllSelectedMain : this.AreTheyAllSelectedMain &&  this.AreTheyAllSelectedSecond
            return theyAreAllChecked ? '/img/newsletters-v2/checkbox-2-on.svg' : '/img/newsletters-v2/checkbox-2-off.svg'
        },

        checkboxAllSrcSpam() {
            return this.AreTheyAllSelectedSecond ? '/img/newsletters-v2/checkbox-2-on.svg' : '/img/newsletters-v2/checkbox-2-off.svg'
        },

        totalSelectedMain() {
            return this.mainList.filter(item => item.checked).length
        },

        totalSelectedSecond() {
            return this.secondList.filter(item => item.checked).length
        },

        totalSelectedToShow() {
            return this.isSpamList
                ? this.totalSelectedSecond
                : this.totalSelectedSecond + this.totalSelectedMain
        },

        AreTheyAllSelectedMain() {
            return this.totalSelectedMain === this.mainList.length
        },

        AreTheyAllSelectedSecond() {
            return this.totalSelectedSecond === this.secondList.length
        },

        totalItemsMain() {
            return this.isSpamList
                ? this.mainList.length
                : this.mainList.length + this.secondList.length
        }
    },

    methods: {
        toggleAllMain() {
            const needToSelectAll = !(this.AreTheyAllSelectedMain && this.AreTheyAllSelectedSecond)
            this.toggleFirstColumn(needToSelectAll)

            if(!this.isSpamList) {
                this.toggleSecondColumn(needToSelectAll)
            }
        },

        toggleFirstColumn(needToSelectAll) {
            needToSelectAll
                ? this.mainList.forEach(item => item.checked = true)
                : this.mainList.forEach(item => item.checked = false)
        },

        toggleSecondColumn(needToSelectAll) {
            needToSelectAll
                ? this.secondList.forEach(item => item.checked = true)
                : this.secondList.forEach(item => item.checked = false)
        },

        unselectAllMain() {
            this.mainList.forEach(item => item.checked = false)
        },

        unselectAllSecond() {
            this.secondList.forEach(item => item.checked = false)
        },

        unselectAllSpam() {
            if(!this.isSpamList) {
                this.unselectAllMain()
            }
            this.unselectAllSecond()
        }
    }
}
</script>

<style lang="scss" scoped>

.header-desktop {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    box-shadow: 0px 1px 0px 0px #D5D7DA;

    .element {
        width: 100%;
        padding: 32px 16px 16px;
        max-width: 460px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;

        .side {
            cursor: pointer;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;

            .line {
                display: flex;
                flex-direction: row;
                align-items: center;
            }

            .blue-bubble {
                padding: 2px 6px;
                border-radius: 16px;
                background-color: $aquamarine;
                color: $white;
            }
        }
    }

    .two-columns {
        margin-right: 36px;
        margin-left: 36px;
    }
}
</style>
